import { terminalView } from '@fareye/configs'
import { Flex, styled } from '@fareye/ui'
import React from 'react'
import { Timer } from './Timer'
import { useTimer } from '../hooks/useTimer'
import logo from '../assets/fareye-logo-white.png'

const TerminalViewHeader: any = styled(Flex)`
  color: ${terminalView.darkTheme.textColor};
  height: 80px;
  overflow: hidden;
  align-items: center;
  margin-left: 16px;
  margin-right: 16px;
  @media (min-width: 1920px) and (max-width: 3840px) {
    margin-left: 50px;
    margin-right: 30px;
    height: 100px;
  }
  @media (min-width: 3840px) {
    margin-left: 130px;
    margin-right: 111px;
    height: 216px;
  }
`

const HubContainer: any = styled(Flex)`
  margin-right: auto;
`
const ArrivalDepartureContainer: any = styled(Flex)`
  justify-content: flex-end;
  align-items: center;
  margin-left: 20px;
  background: ${terminalView.darkTheme.timer.background};
  border-radius: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
  height: 48px;
  padding: 0px 16px;
  @media (min-width: 1920px) and (max-width: 3840px) {
    padding-right: 30px;
    padding-left: 20px;
    height: 52px;
  }
  @media (min-width: 3840px) {
    padding-right: 40px;
    padding-left: 20px;
    margin-left: 100px;
    height: 144px;
  }
`

export const Header = function(props: any) {
  const { setRefreshData, config, view, hub } = props
  const [timer] = useTimer(
    setRefreshData,
    config?.page?.dataRefreshTimeInterval
  )
  return (
    <TerminalViewHeader>
      <img
        src={logo}
        alt="fareye-logo"
        style={{
          height: '70px',
          width: 'auto'
        }}
      />
      <HubContainer>
        <ArrivalDepartureContainer>
          {hub ? hub.toUpperCase() : '-'}
        </ArrivalDepartureContainer>
        <ArrivalDepartureContainer>
          {view.replace('_', ' & ').toUpperCase()}
        </ArrivalDepartureContainer>
      </HubContainer>
      <Timer>{timer}</Timer>
    </TerminalViewHeader>
  )
}
